angular.module 'zc.masterApi'

.factory 'MasterUser', ($q, $resource, Api) ->

  MasterUser = $resource Api.path("/api/master/users"), {},
    all:
      method: 'GET'
      isArray: false # Rails returns object instead of array

  service =
    all: (params) ->
      d = $q.defer()
      MasterUser.all(params).$promise.then (res) ->
        d.resolve res
      , (err) ->
        d.reject err
      d.promise

  service




// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_user.service.js.coffee